/* tslint:disable */
/* eslint-disable */
/**
 * FanFair Complete API
 * Complete API documentation for FanFair platform including both public and private endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateMerchantOnboardingSubmissionRequest } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { MerchantOnboardingLinkRefreshed } from '../models';
// @ts-ignore
import type { MerchantOnboardingLinkResponse } from '../models';
// @ts-ignore
import type { MerchantOnboardingSession } from '../models';
// @ts-ignore
import type { MerchantOnboardingSessionSubmissionRequest } from '../models';
// @ts-ignore
import type { MerchantOnboardingSubmissionCreatedResponse } from '../models';
// @ts-ignore
import type { MerchantOnboardingSubmissionDetail } from '../models';
// @ts-ignore
import type { MerchantOnboardingSubmissionStatus } from '../models';
// @ts-ignore
import type { MerchantOnboardingVerificationConfirmRequest } from '../models';
// @ts-ignore
import type { MerchantOnboardingVerificationConfirmed } from '../models';
// @ts-ignore
import type { MerchantOnboardingVerificationRequest } from '../models';
// @ts-ignore
import type { MerchantOnboardingVerificationRequested } from '../models';
// @ts-ignore
import type { PagedMerchantOnboardingSubmissionResponse } from '../models';
// @ts-ignore
import type { PublicMerchantOnboardingLinkResponse } from '../models';
// @ts-ignore
import type { UpdateMerchantOnboardingLinkRequest } from '../models';
/**
 * MerchantOnboardingApi - axios parameter creator
 * @export
 */
export const MerchantOnboardingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Public, unauthenticated. Checks the 6-digit code for the email. On success it returns a short-lived onboarding token, bound to this link and email, which authorises the `/session` endpoints through the `X-Onboarding-Token` header. A wrong code returns 400 `ONBOARDING_CODE_INVALID` with `details.attemptsRemaining`; after too many tries the code is burned and a new one must be requested. 
         * @summary Confirm an email verification code
         * @param {string} key The onboarding link key
         * @param {MerchantOnboardingVerificationConfirmRequest} merchantOnboardingVerificationConfirmRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmMerchantOnboardingVerificationV1: async (key: string, merchantOnboardingVerificationConfirmRequest: MerchantOnboardingVerificationConfirmRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('confirmMerchantOnboardingVerificationV1', 'key', key)
            // verify required parameter 'merchantOnboardingVerificationConfirmRequest' is not null or undefined
            assertParamExists('confirmMerchantOnboardingVerificationV1', 'merchantOnboardingVerificationConfirmRequest', merchantOnboardingVerificationConfirmRequest)
            const localVarPath = `/api/v1/public/merchant-onboarding/links/{key}/verifications/confirm`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(merchantOnboardingVerificationConfirmRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Public, unauthenticated. Creates a minimal merchant under the link\'s partner, boards it on Fiserv Forward on the default processing plan, and returns Forward\'s hosted application link. One email can hold one open application per partner: a clash returns 409 `ONBOARDING_EMAIL_IN_USE` with the held status in `details.status`, and never the link. Resubmitting an email whose boarding failed resumes it. Rate limited per client IP. 
         * @summary Submit a merchant self-onboarding application
         * @param {string} key The onboarding link key
         * @param {CreateMerchantOnboardingSubmissionRequest} createMerchantOnboardingSubmissionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMerchantOnboardingSubmissionV1: async (key: string, createMerchantOnboardingSubmissionRequest: CreateMerchantOnboardingSubmissionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('createMerchantOnboardingSubmissionV1', 'key', key)
            // verify required parameter 'createMerchantOnboardingSubmissionRequest' is not null or undefined
            assertParamExists('createMerchantOnboardingSubmissionV1', 'createMerchantOnboardingSubmissionRequest', createMerchantOnboardingSubmissionRequest)
            const localVarPath = `/api/v1/public/merchant-onboarding/links/{key}/submissions`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMerchantOnboardingSubmissionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the calling partner\'s one self-onboarding link. The link is created on first read, disabled, so nothing is reachable until the partner enables it. Only partners with a Fiserv Forward gateway configuration can have a link; any other partner gets 409 `ONBOARDING_NOT_AVAILABLE`. Gated by `merchant-onboarding-link:read`. 
         * @summary Get the partner\'s merchant onboarding link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantOnboardingLinkV1: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/merchant-onboarding/link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Public, authorised by the `X-Onboarding-Token` from a confirmed verification. Returns the partner\'s display name, the verified email, and the current application for that email if one exists, so a returning merchant can resume. An expired or unknown token returns 401 `ONBOARDING_SESSION_EXPIRED`. 
         * @summary Read the verified onboarding session
         * @param {string} xOnboardingToken The onboarding token from a confirmed verification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantOnboardingSessionV1: async (xOnboardingToken: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xOnboardingToken' is not null or undefined
            assertParamExists('getMerchantOnboardingSessionV1', 'xOnboardingToken', xOnboardingToken)
            const localVarPath = `/api/v1/public/merchant-onboarding/session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xOnboardingToken != null) {
                localVarHeaderParameter['X-Onboarding-Token'] = String(xOnboardingToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The submission and a read-only summary of its merchant. Another partner\'s submission is `404`. Gated by `merchant-onboarding-submission:read`. 
         * @summary Get a merchant self-onboarding submission
         * @param {string} id Onboarding submission ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantOnboardingSubmission: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMerchantOnboardingSubmission', 'id', id)
            const localVarPath = `/api/v1/merchant-onboarding/submissions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Public, unauthenticated. Returns the partner\'s display name for an enabled link. An unknown, disabled or rotated key returns the same 404 `ONBOARDING_LINK_NOT_FOUND`. Rate limited per client IP. 
         * @summary Look up a merchant onboarding link
         * @param {string} key The onboarding link key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicMerchantOnboardingLinkV1: async (key: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('getPublicMerchantOnboardingLinkV1', 'key', key)
            const localVarPath = `/api/v1/public/merchant-onboarding/links/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The calling partner\'s self-onboarding submissions, newest first. Gated by `merchant-onboarding-submission:read`. 
         * @summary List the partner\'s merchant self-onboarding submissions
         * @param {number} [page] The zero-based index of the page of results to return.
         * @param {number} [size] The maximum number of results to return in a page.
         * @param {MerchantOnboardingSubmissionStatus} [status] Only submissions in this status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMerchantOnboardingSubmissions: async (page?: number, size?: number, status?: MerchantOnboardingSubmissionStatus, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/merchant-onboarding/submissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Public, authorised by the `X-Onboarding-Token` from a confirmed verification. Issues a fresh Fiserv Forward hosted application link for the merchant\'s existing application and restarts its expiry window, so a merchant who lost the original email can resume without contacting the partner. 
         * @summary Refresh the Fiserv onboarding link for the session
         * @param {string} xOnboardingToken The onboarding token from a confirmed verification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshMerchantOnboardingLinkV1: async (xOnboardingToken: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xOnboardingToken' is not null or undefined
            assertParamExists('refreshMerchantOnboardingLinkV1', 'xOnboardingToken', xOnboardingToken)
            const localVarPath = `/api/v1/public/merchant-onboarding/session/onboarding-link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (xOnboardingToken != null) {
                localVarHeaderParameter['X-Onboarding-Token'] = String(xOnboardingToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Only while the submission is `LINK_ISSUED` or `BOARDING_FAILED`. The submission becomes `RELEASED`, its merchant `INACTIVE`, and the email can start a new application. Audited. Gated by `merchant-onboarding-submission:update`. 
         * @summary Release the email held by a self-onboarding submission
         * @param {string} id Onboarding submission ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseMerchantOnboardingSubmission: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('releaseMerchantOnboardingSubmission', 'id', id)
            const localVarPath = `/api/v1/merchant-onboarding/submissions/{id}/release`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Public, unauthenticated. Sends a 6-digit verification code to the email address so the merchant can prove it before applying. Always responds `202` for a live link and a syntactically valid email, whether or not a code was sent, so the response never reveals whether an address already has an application. Requesting again supersedes the previous code. Rate limited per email and per client IP. 
         * @summary Request an email verification code
         * @param {string} key The onboarding link key
         * @param {MerchantOnboardingVerificationRequest} merchantOnboardingVerificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestMerchantOnboardingVerificationV1: async (key: string, merchantOnboardingVerificationRequest: MerchantOnboardingVerificationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('requestMerchantOnboardingVerificationV1', 'key', key)
            // verify required parameter 'merchantOnboardingVerificationRequest' is not null or undefined
            assertParamExists('requestMerchantOnboardingVerificationV1', 'merchantOnboardingVerificationRequest', merchantOnboardingVerificationRequest)
            const localVarPath = `/api/v1/public/merchant-onboarding/links/{key}/verifications`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(merchantOnboardingVerificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Issues a new link key. The old key stops working at once. The enabled flag is unchanged. Audited. Gated by `merchant-onboarding-link:update`. 
         * @summary Rotate the partner\'s merchant onboarding link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rotateMerchantOnboardingLinkV1: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/merchant-onboarding/link/rotate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Public, authorised by the `X-Onboarding-Token` from a confirmed verification. Creates a minimal merchant under the link\'s partner using the verified email, boards it on Fiserv Forward on the default processing plan, and returns Forward\'s hosted application link. One email can hold one open application per partner: a clash returns 409 `ONBOARDING_EMAIL_IN_USE` with the held status in `details.status`. 
         * @summary Submit a verified self-onboarding application
         * @param {string} xOnboardingToken The onboarding token from a confirmed verification
         * @param {MerchantOnboardingSessionSubmissionRequest} merchantOnboardingSessionSubmissionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitMerchantOnboardingSessionV1: async (xOnboardingToken: string, merchantOnboardingSessionSubmissionRequest: MerchantOnboardingSessionSubmissionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xOnboardingToken' is not null or undefined
            assertParamExists('submitMerchantOnboardingSessionV1', 'xOnboardingToken', xOnboardingToken)
            // verify required parameter 'merchantOnboardingSessionSubmissionRequest' is not null or undefined
            assertParamExists('submitMerchantOnboardingSessionV1', 'merchantOnboardingSessionSubmissionRequest', merchantOnboardingSessionSubmissionRequest)
            const localVarPath = `/api/v1/public/merchant-onboarding/session/submission`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xOnboardingToken != null) {
                localVarHeaderParameter['X-Onboarding-Token'] = String(xOnboardingToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(merchantOnboardingSessionSubmissionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Turns the onboarding link on or off. Audited. Gated by `merchant-onboarding-link:update`.
         * @summary Enable or disable the partner\'s merchant onboarding link
         * @param {UpdateMerchantOnboardingLinkRequest} updateMerchantOnboardingLinkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMerchantOnboardingLinkV1: async (updateMerchantOnboardingLinkRequest: UpdateMerchantOnboardingLinkRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateMerchantOnboardingLinkRequest' is not null or undefined
            assertParamExists('updateMerchantOnboardingLinkV1', 'updateMerchantOnboardingLinkRequest', updateMerchantOnboardingLinkRequest)
            const localVarPath = `/api/v1/merchant-onboarding/link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMerchantOnboardingLinkRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MerchantOnboardingApi - functional programming interface
 * @export
 */
export const MerchantOnboardingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MerchantOnboardingApiAxiosParamCreator(configuration)
    return {
        /**
         * Public, unauthenticated. Checks the 6-digit code for the email. On success it returns a short-lived onboarding token, bound to this link and email, which authorises the `/session` endpoints through the `X-Onboarding-Token` header. A wrong code returns 400 `ONBOARDING_CODE_INVALID` with `details.attemptsRemaining`; after too many tries the code is burned and a new one must be requested. 
         * @summary Confirm an email verification code
         * @param {string} key The onboarding link key
         * @param {MerchantOnboardingVerificationConfirmRequest} merchantOnboardingVerificationConfirmRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmMerchantOnboardingVerificationV1(key: string, merchantOnboardingVerificationConfirmRequest: MerchantOnboardingVerificationConfirmRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MerchantOnboardingVerificationConfirmed>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmMerchantOnboardingVerificationV1(key, merchantOnboardingVerificationConfirmRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantOnboardingApi.confirmMerchantOnboardingVerificationV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Public, unauthenticated. Creates a minimal merchant under the link\'s partner, boards it on Fiserv Forward on the default processing plan, and returns Forward\'s hosted application link. One email can hold one open application per partner: a clash returns 409 `ONBOARDING_EMAIL_IN_USE` with the held status in `details.status`, and never the link. Resubmitting an email whose boarding failed resumes it. Rate limited per client IP. 
         * @summary Submit a merchant self-onboarding application
         * @param {string} key The onboarding link key
         * @param {CreateMerchantOnboardingSubmissionRequest} createMerchantOnboardingSubmissionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMerchantOnboardingSubmissionV1(key: string, createMerchantOnboardingSubmissionRequest: CreateMerchantOnboardingSubmissionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MerchantOnboardingSubmissionCreatedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMerchantOnboardingSubmissionV1(key, createMerchantOnboardingSubmissionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantOnboardingApi.createMerchantOnboardingSubmissionV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the calling partner\'s one self-onboarding link. The link is created on first read, disabled, so nothing is reachable until the partner enables it. Only partners with a Fiserv Forward gateway configuration can have a link; any other partner gets 409 `ONBOARDING_NOT_AVAILABLE`. Gated by `merchant-onboarding-link:read`. 
         * @summary Get the partner\'s merchant onboarding link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchantOnboardingLinkV1(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MerchantOnboardingLinkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchantOnboardingLinkV1(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantOnboardingApi.getMerchantOnboardingLinkV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Public, authorised by the `X-Onboarding-Token` from a confirmed verification. Returns the partner\'s display name, the verified email, and the current application for that email if one exists, so a returning merchant can resume. An expired or unknown token returns 401 `ONBOARDING_SESSION_EXPIRED`. 
         * @summary Read the verified onboarding session
         * @param {string} xOnboardingToken The onboarding token from a confirmed verification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchantOnboardingSessionV1(xOnboardingToken: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MerchantOnboardingSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchantOnboardingSessionV1(xOnboardingToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantOnboardingApi.getMerchantOnboardingSessionV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The submission and a read-only summary of its merchant. Another partner\'s submission is `404`. Gated by `merchant-onboarding-submission:read`. 
         * @summary Get a merchant self-onboarding submission
         * @param {string} id Onboarding submission ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchantOnboardingSubmission(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MerchantOnboardingSubmissionDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchantOnboardingSubmission(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantOnboardingApi.getMerchantOnboardingSubmission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Public, unauthenticated. Returns the partner\'s display name for an enabled link. An unknown, disabled or rotated key returns the same 404 `ONBOARDING_LINK_NOT_FOUND`. Rate limited per client IP. 
         * @summary Look up a merchant onboarding link
         * @param {string} key The onboarding link key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicMerchantOnboardingLinkV1(key: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicMerchantOnboardingLinkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicMerchantOnboardingLinkV1(key, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantOnboardingApi.getPublicMerchantOnboardingLinkV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * The calling partner\'s self-onboarding submissions, newest first. Gated by `merchant-onboarding-submission:read`. 
         * @summary List the partner\'s merchant self-onboarding submissions
         * @param {number} [page] The zero-based index of the page of results to return.
         * @param {number} [size] The maximum number of results to return in a page.
         * @param {MerchantOnboardingSubmissionStatus} [status] Only submissions in this status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMerchantOnboardingSubmissions(page?: number, size?: number, status?: MerchantOnboardingSubmissionStatus, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedMerchantOnboardingSubmissionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMerchantOnboardingSubmissions(page, size, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantOnboardingApi.listMerchantOnboardingSubmissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Public, authorised by the `X-Onboarding-Token` from a confirmed verification. Issues a fresh Fiserv Forward hosted application link for the merchant\'s existing application and restarts its expiry window, so a merchant who lost the original email can resume without contacting the partner. 
         * @summary Refresh the Fiserv onboarding link for the session
         * @param {string} xOnboardingToken The onboarding token from a confirmed verification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshMerchantOnboardingLinkV1(xOnboardingToken: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MerchantOnboardingLinkRefreshed>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshMerchantOnboardingLinkV1(xOnboardingToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantOnboardingApi.refreshMerchantOnboardingLinkV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Only while the submission is `LINK_ISSUED` or `BOARDING_FAILED`. The submission becomes `RELEASED`, its merchant `INACTIVE`, and the email can start a new application. Audited. Gated by `merchant-onboarding-submission:update`. 
         * @summary Release the email held by a self-onboarding submission
         * @param {string} id Onboarding submission ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async releaseMerchantOnboardingSubmission(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MerchantOnboardingSubmissionDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.releaseMerchantOnboardingSubmission(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantOnboardingApi.releaseMerchantOnboardingSubmission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Public, unauthenticated. Sends a 6-digit verification code to the email address so the merchant can prove it before applying. Always responds `202` for a live link and a syntactically valid email, whether or not a code was sent, so the response never reveals whether an address already has an application. Requesting again supersedes the previous code. Rate limited per email and per client IP. 
         * @summary Request an email verification code
         * @param {string} key The onboarding link key
         * @param {MerchantOnboardingVerificationRequest} merchantOnboardingVerificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestMerchantOnboardingVerificationV1(key: string, merchantOnboardingVerificationRequest: MerchantOnboardingVerificationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MerchantOnboardingVerificationRequested>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestMerchantOnboardingVerificationV1(key, merchantOnboardingVerificationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantOnboardingApi.requestMerchantOnboardingVerificationV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Issues a new link key. The old key stops working at once. The enabled flag is unchanged. Audited. Gated by `merchant-onboarding-link:update`. 
         * @summary Rotate the partner\'s merchant onboarding link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rotateMerchantOnboardingLinkV1(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MerchantOnboardingLinkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rotateMerchantOnboardingLinkV1(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantOnboardingApi.rotateMerchantOnboardingLinkV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Public, authorised by the `X-Onboarding-Token` from a confirmed verification. Creates a minimal merchant under the link\'s partner using the verified email, boards it on Fiserv Forward on the default processing plan, and returns Forward\'s hosted application link. One email can hold one open application per partner: a clash returns 409 `ONBOARDING_EMAIL_IN_USE` with the held status in `details.status`. 
         * @summary Submit a verified self-onboarding application
         * @param {string} xOnboardingToken The onboarding token from a confirmed verification
         * @param {MerchantOnboardingSessionSubmissionRequest} merchantOnboardingSessionSubmissionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitMerchantOnboardingSessionV1(xOnboardingToken: string, merchantOnboardingSessionSubmissionRequest: MerchantOnboardingSessionSubmissionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MerchantOnboardingSubmissionCreatedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitMerchantOnboardingSessionV1(xOnboardingToken, merchantOnboardingSessionSubmissionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantOnboardingApi.submitMerchantOnboardingSessionV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Turns the onboarding link on or off. Audited. Gated by `merchant-onboarding-link:update`.
         * @summary Enable or disable the partner\'s merchant onboarding link
         * @param {UpdateMerchantOnboardingLinkRequest} updateMerchantOnboardingLinkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMerchantOnboardingLinkV1(updateMerchantOnboardingLinkRequest: UpdateMerchantOnboardingLinkRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MerchantOnboardingLinkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMerchantOnboardingLinkV1(updateMerchantOnboardingLinkRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantOnboardingApi.updateMerchantOnboardingLinkV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MerchantOnboardingApi - factory interface
 * @export
 */
export const MerchantOnboardingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MerchantOnboardingApiFp(configuration)
    return {
        /**
         * Public, unauthenticated. Checks the 6-digit code for the email. On success it returns a short-lived onboarding token, bound to this link and email, which authorises the `/session` endpoints through the `X-Onboarding-Token` header. A wrong code returns 400 `ONBOARDING_CODE_INVALID` with `details.attemptsRemaining`; after too many tries the code is burned and a new one must be requested. 
         * @summary Confirm an email verification code
         * @param {string} key The onboarding link key
         * @param {MerchantOnboardingVerificationConfirmRequest} merchantOnboardingVerificationConfirmRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmMerchantOnboardingVerificationV1(key: string, merchantOnboardingVerificationConfirmRequest: MerchantOnboardingVerificationConfirmRequest, options?: RawAxiosRequestConfig): AxiosPromise<MerchantOnboardingVerificationConfirmed> {
            return localVarFp.confirmMerchantOnboardingVerificationV1(key, merchantOnboardingVerificationConfirmRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Public, unauthenticated. Creates a minimal merchant under the link\'s partner, boards it on Fiserv Forward on the default processing plan, and returns Forward\'s hosted application link. One email can hold one open application per partner: a clash returns 409 `ONBOARDING_EMAIL_IN_USE` with the held status in `details.status`, and never the link. Resubmitting an email whose boarding failed resumes it. Rate limited per client IP. 
         * @summary Submit a merchant self-onboarding application
         * @param {string} key The onboarding link key
         * @param {CreateMerchantOnboardingSubmissionRequest} createMerchantOnboardingSubmissionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMerchantOnboardingSubmissionV1(key: string, createMerchantOnboardingSubmissionRequest: CreateMerchantOnboardingSubmissionRequest, options?: RawAxiosRequestConfig): AxiosPromise<MerchantOnboardingSubmissionCreatedResponse> {
            return localVarFp.createMerchantOnboardingSubmissionV1(key, createMerchantOnboardingSubmissionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the calling partner\'s one self-onboarding link. The link is created on first read, disabled, so nothing is reachable until the partner enables it. Only partners with a Fiserv Forward gateway configuration can have a link; any other partner gets 409 `ONBOARDING_NOT_AVAILABLE`. Gated by `merchant-onboarding-link:read`. 
         * @summary Get the partner\'s merchant onboarding link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantOnboardingLinkV1(options?: RawAxiosRequestConfig): AxiosPromise<MerchantOnboardingLinkResponse> {
            return localVarFp.getMerchantOnboardingLinkV1(options).then((request) => request(axios, basePath));
        },
        /**
         * Public, authorised by the `X-Onboarding-Token` from a confirmed verification. Returns the partner\'s display name, the verified email, and the current application for that email if one exists, so a returning merchant can resume. An expired or unknown token returns 401 `ONBOARDING_SESSION_EXPIRED`. 
         * @summary Read the verified onboarding session
         * @param {string} xOnboardingToken The onboarding token from a confirmed verification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantOnboardingSessionV1(xOnboardingToken: string, options?: RawAxiosRequestConfig): AxiosPromise<MerchantOnboardingSession> {
            return localVarFp.getMerchantOnboardingSessionV1(xOnboardingToken, options).then((request) => request(axios, basePath));
        },
        /**
         * The submission and a read-only summary of its merchant. Another partner\'s submission is `404`. Gated by `merchant-onboarding-submission:read`. 
         * @summary Get a merchant self-onboarding submission
         * @param {string} id Onboarding submission ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantOnboardingSubmission(id: string, options?: RawAxiosRequestConfig): AxiosPromise<MerchantOnboardingSubmissionDetail> {
            return localVarFp.getMerchantOnboardingSubmission(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Public, unauthenticated. Returns the partner\'s display name for an enabled link. An unknown, disabled or rotated key returns the same 404 `ONBOARDING_LINK_NOT_FOUND`. Rate limited per client IP. 
         * @summary Look up a merchant onboarding link
         * @param {string} key The onboarding link key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicMerchantOnboardingLinkV1(key: string, options?: RawAxiosRequestConfig): AxiosPromise<PublicMerchantOnboardingLinkResponse> {
            return localVarFp.getPublicMerchantOnboardingLinkV1(key, options).then((request) => request(axios, basePath));
        },
        /**
         * The calling partner\'s self-onboarding submissions, newest first. Gated by `merchant-onboarding-submission:read`. 
         * @summary List the partner\'s merchant self-onboarding submissions
         * @param {number} [page] The zero-based index of the page of results to return.
         * @param {number} [size] The maximum number of results to return in a page.
         * @param {MerchantOnboardingSubmissionStatus} [status] Only submissions in this status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMerchantOnboardingSubmissions(page?: number, size?: number, status?: MerchantOnboardingSubmissionStatus, options?: RawAxiosRequestConfig): AxiosPromise<PagedMerchantOnboardingSubmissionResponse> {
            return localVarFp.listMerchantOnboardingSubmissions(page, size, status, options).then((request) => request(axios, basePath));
        },
        /**
         * Public, authorised by the `X-Onboarding-Token` from a confirmed verification. Issues a fresh Fiserv Forward hosted application link for the merchant\'s existing application and restarts its expiry window, so a merchant who lost the original email can resume without contacting the partner. 
         * @summary Refresh the Fiserv onboarding link for the session
         * @param {string} xOnboardingToken The onboarding token from a confirmed verification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshMerchantOnboardingLinkV1(xOnboardingToken: string, options?: RawAxiosRequestConfig): AxiosPromise<MerchantOnboardingLinkRefreshed> {
            return localVarFp.refreshMerchantOnboardingLinkV1(xOnboardingToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Only while the submission is `LINK_ISSUED` or `BOARDING_FAILED`. The submission becomes `RELEASED`, its merchant `INACTIVE`, and the email can start a new application. Audited. Gated by `merchant-onboarding-submission:update`. 
         * @summary Release the email held by a self-onboarding submission
         * @param {string} id Onboarding submission ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseMerchantOnboardingSubmission(id: string, options?: RawAxiosRequestConfig): AxiosPromise<MerchantOnboardingSubmissionDetail> {
            return localVarFp.releaseMerchantOnboardingSubmission(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Public, unauthenticated. Sends a 6-digit verification code to the email address so the merchant can prove it before applying. Always responds `202` for a live link and a syntactically valid email, whether or not a code was sent, so the response never reveals whether an address already has an application. Requesting again supersedes the previous code. Rate limited per email and per client IP. 
         * @summary Request an email verification code
         * @param {string} key The onboarding link key
         * @param {MerchantOnboardingVerificationRequest} merchantOnboardingVerificationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestMerchantOnboardingVerificationV1(key: string, merchantOnboardingVerificationRequest: MerchantOnboardingVerificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<MerchantOnboardingVerificationRequested> {
            return localVarFp.requestMerchantOnboardingVerificationV1(key, merchantOnboardingVerificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Issues a new link key. The old key stops working at once. The enabled flag is unchanged. Audited. Gated by `merchant-onboarding-link:update`. 
         * @summary Rotate the partner\'s merchant onboarding link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rotateMerchantOnboardingLinkV1(options?: RawAxiosRequestConfig): AxiosPromise<MerchantOnboardingLinkResponse> {
            return localVarFp.rotateMerchantOnboardingLinkV1(options).then((request) => request(axios, basePath));
        },
        /**
         * Public, authorised by the `X-Onboarding-Token` from a confirmed verification. Creates a minimal merchant under the link\'s partner using the verified email, boards it on Fiserv Forward on the default processing plan, and returns Forward\'s hosted application link. One email can hold one open application per partner: a clash returns 409 `ONBOARDING_EMAIL_IN_USE` with the held status in `details.status`. 
         * @summary Submit a verified self-onboarding application
         * @param {string} xOnboardingToken The onboarding token from a confirmed verification
         * @param {MerchantOnboardingSessionSubmissionRequest} merchantOnboardingSessionSubmissionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitMerchantOnboardingSessionV1(xOnboardingToken: string, merchantOnboardingSessionSubmissionRequest: MerchantOnboardingSessionSubmissionRequest, options?: RawAxiosRequestConfig): AxiosPromise<MerchantOnboardingSubmissionCreatedResponse> {
            return localVarFp.submitMerchantOnboardingSessionV1(xOnboardingToken, merchantOnboardingSessionSubmissionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Turns the onboarding link on or off. Audited. Gated by `merchant-onboarding-link:update`.
         * @summary Enable or disable the partner\'s merchant onboarding link
         * @param {UpdateMerchantOnboardingLinkRequest} updateMerchantOnboardingLinkRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMerchantOnboardingLinkV1(updateMerchantOnboardingLinkRequest: UpdateMerchantOnboardingLinkRequest, options?: RawAxiosRequestConfig): AxiosPromise<MerchantOnboardingLinkResponse> {
            return localVarFp.updateMerchantOnboardingLinkV1(updateMerchantOnboardingLinkRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MerchantOnboardingApi - object-oriented interface
 * @export
 * @class MerchantOnboardingApi
 * @extends {BaseAPI}
 */
export class MerchantOnboardingApi extends BaseAPI {
    /**
     * Public, unauthenticated. Checks the 6-digit code for the email. On success it returns a short-lived onboarding token, bound to this link and email, which authorises the `/session` endpoints through the `X-Onboarding-Token` header. A wrong code returns 400 `ONBOARDING_CODE_INVALID` with `details.attemptsRemaining`; after too many tries the code is burned and a new one must be requested. 
     * @summary Confirm an email verification code
     * @param {string} key The onboarding link key
     * @param {MerchantOnboardingVerificationConfirmRequest} merchantOnboardingVerificationConfirmRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantOnboardingApi
     */
    public confirmMerchantOnboardingVerificationV1(key: string, merchantOnboardingVerificationConfirmRequest: MerchantOnboardingVerificationConfirmRequest, options?: RawAxiosRequestConfig) {
        return MerchantOnboardingApiFp(this.configuration).confirmMerchantOnboardingVerificationV1(key, merchantOnboardingVerificationConfirmRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Public, unauthenticated. Creates a minimal merchant under the link\'s partner, boards it on Fiserv Forward on the default processing plan, and returns Forward\'s hosted application link. One email can hold one open application per partner: a clash returns 409 `ONBOARDING_EMAIL_IN_USE` with the held status in `details.status`, and never the link. Resubmitting an email whose boarding failed resumes it. Rate limited per client IP. 
     * @summary Submit a merchant self-onboarding application
     * @param {string} key The onboarding link key
     * @param {CreateMerchantOnboardingSubmissionRequest} createMerchantOnboardingSubmissionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantOnboardingApi
     */
    public createMerchantOnboardingSubmissionV1(key: string, createMerchantOnboardingSubmissionRequest: CreateMerchantOnboardingSubmissionRequest, options?: RawAxiosRequestConfig) {
        return MerchantOnboardingApiFp(this.configuration).createMerchantOnboardingSubmissionV1(key, createMerchantOnboardingSubmissionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the calling partner\'s one self-onboarding link. The link is created on first read, disabled, so nothing is reachable until the partner enables it. Only partners with a Fiserv Forward gateway configuration can have a link; any other partner gets 409 `ONBOARDING_NOT_AVAILABLE`. Gated by `merchant-onboarding-link:read`. 
     * @summary Get the partner\'s merchant onboarding link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantOnboardingApi
     */
    public getMerchantOnboardingLinkV1(options?: RawAxiosRequestConfig) {
        return MerchantOnboardingApiFp(this.configuration).getMerchantOnboardingLinkV1(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Public, authorised by the `X-Onboarding-Token` from a confirmed verification. Returns the partner\'s display name, the verified email, and the current application for that email if one exists, so a returning merchant can resume. An expired or unknown token returns 401 `ONBOARDING_SESSION_EXPIRED`. 
     * @summary Read the verified onboarding session
     * @param {string} xOnboardingToken The onboarding token from a confirmed verification
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantOnboardingApi
     */
    public getMerchantOnboardingSessionV1(xOnboardingToken: string, options?: RawAxiosRequestConfig) {
        return MerchantOnboardingApiFp(this.configuration).getMerchantOnboardingSessionV1(xOnboardingToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The submission and a read-only summary of its merchant. Another partner\'s submission is `404`. Gated by `merchant-onboarding-submission:read`. 
     * @summary Get a merchant self-onboarding submission
     * @param {string} id Onboarding submission ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantOnboardingApi
     */
    public getMerchantOnboardingSubmission(id: string, options?: RawAxiosRequestConfig) {
        return MerchantOnboardingApiFp(this.configuration).getMerchantOnboardingSubmission(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Public, unauthenticated. Returns the partner\'s display name for an enabled link. An unknown, disabled or rotated key returns the same 404 `ONBOARDING_LINK_NOT_FOUND`. Rate limited per client IP. 
     * @summary Look up a merchant onboarding link
     * @param {string} key The onboarding link key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantOnboardingApi
     */
    public getPublicMerchantOnboardingLinkV1(key: string, options?: RawAxiosRequestConfig) {
        return MerchantOnboardingApiFp(this.configuration).getPublicMerchantOnboardingLinkV1(key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * The calling partner\'s self-onboarding submissions, newest first. Gated by `merchant-onboarding-submission:read`. 
     * @summary List the partner\'s merchant self-onboarding submissions
     * @param {number} [page] The zero-based index of the page of results to return.
     * @param {number} [size] The maximum number of results to return in a page.
     * @param {MerchantOnboardingSubmissionStatus} [status] Only submissions in this status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantOnboardingApi
     */
    public listMerchantOnboardingSubmissions(page?: number, size?: number, status?: MerchantOnboardingSubmissionStatus, options?: RawAxiosRequestConfig) {
        return MerchantOnboardingApiFp(this.configuration).listMerchantOnboardingSubmissions(page, size, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Public, authorised by the `X-Onboarding-Token` from a confirmed verification. Issues a fresh Fiserv Forward hosted application link for the merchant\'s existing application and restarts its expiry window, so a merchant who lost the original email can resume without contacting the partner. 
     * @summary Refresh the Fiserv onboarding link for the session
     * @param {string} xOnboardingToken The onboarding token from a confirmed verification
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantOnboardingApi
     */
    public refreshMerchantOnboardingLinkV1(xOnboardingToken: string, options?: RawAxiosRequestConfig) {
        return MerchantOnboardingApiFp(this.configuration).refreshMerchantOnboardingLinkV1(xOnboardingToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Only while the submission is `LINK_ISSUED` or `BOARDING_FAILED`. The submission becomes `RELEASED`, its merchant `INACTIVE`, and the email can start a new application. Audited. Gated by `merchant-onboarding-submission:update`. 
     * @summary Release the email held by a self-onboarding submission
     * @param {string} id Onboarding submission ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantOnboardingApi
     */
    public releaseMerchantOnboardingSubmission(id: string, options?: RawAxiosRequestConfig) {
        return MerchantOnboardingApiFp(this.configuration).releaseMerchantOnboardingSubmission(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Public, unauthenticated. Sends a 6-digit verification code to the email address so the merchant can prove it before applying. Always responds `202` for a live link and a syntactically valid email, whether or not a code was sent, so the response never reveals whether an address already has an application. Requesting again supersedes the previous code. Rate limited per email and per client IP. 
     * @summary Request an email verification code
     * @param {string} key The onboarding link key
     * @param {MerchantOnboardingVerificationRequest} merchantOnboardingVerificationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantOnboardingApi
     */
    public requestMerchantOnboardingVerificationV1(key: string, merchantOnboardingVerificationRequest: MerchantOnboardingVerificationRequest, options?: RawAxiosRequestConfig) {
        return MerchantOnboardingApiFp(this.configuration).requestMerchantOnboardingVerificationV1(key, merchantOnboardingVerificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Issues a new link key. The old key stops working at once. The enabled flag is unchanged. Audited. Gated by `merchant-onboarding-link:update`. 
     * @summary Rotate the partner\'s merchant onboarding link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantOnboardingApi
     */
    public rotateMerchantOnboardingLinkV1(options?: RawAxiosRequestConfig) {
        return MerchantOnboardingApiFp(this.configuration).rotateMerchantOnboardingLinkV1(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Public, authorised by the `X-Onboarding-Token` from a confirmed verification. Creates a minimal merchant under the link\'s partner using the verified email, boards it on Fiserv Forward on the default processing plan, and returns Forward\'s hosted application link. One email can hold one open application per partner: a clash returns 409 `ONBOARDING_EMAIL_IN_USE` with the held status in `details.status`. 
     * @summary Submit a verified self-onboarding application
     * @param {string} xOnboardingToken The onboarding token from a confirmed verification
     * @param {MerchantOnboardingSessionSubmissionRequest} merchantOnboardingSessionSubmissionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantOnboardingApi
     */
    public submitMerchantOnboardingSessionV1(xOnboardingToken: string, merchantOnboardingSessionSubmissionRequest: MerchantOnboardingSessionSubmissionRequest, options?: RawAxiosRequestConfig) {
        return MerchantOnboardingApiFp(this.configuration).submitMerchantOnboardingSessionV1(xOnboardingToken, merchantOnboardingSessionSubmissionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Turns the onboarding link on or off. Audited. Gated by `merchant-onboarding-link:update`.
     * @summary Enable or disable the partner\'s merchant onboarding link
     * @param {UpdateMerchantOnboardingLinkRequest} updateMerchantOnboardingLinkRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantOnboardingApi
     */
    public updateMerchantOnboardingLinkV1(updateMerchantOnboardingLinkRequest: UpdateMerchantOnboardingLinkRequest, options?: RawAxiosRequestConfig) {
        return MerchantOnboardingApiFp(this.configuration).updateMerchantOnboardingLinkV1(updateMerchantOnboardingLinkRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

